import logo from './logo.svg';
import MainNavigation from "./components/MainNavigation";
import Footer from "./components/Footer";
import './App.css';
import { useState } from 'react';

function App() {
  const [count, setCount] = useState(0);
  return (
    <div className="App">
      <MainNavigation></MainNavigation>
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <h1>Welcome to 10 Hours of ReactJs Learning!</h1>
        <h3>This is my first react app!</h3>
      </header>
      <Footer></Footer>
      <p> Count: {count}</p>
      <button className='Hello' onClick={()=>setCount(count+1)}>click me</button>
    </div>
  );

  function Clickalert() {
    alert("ss")
  }

}


export default App;
